/**
 * Root layout load.
 *
 * Every route is prerendered by default (the site is content-only). The
 * single dynamic exception is `/api/apply`, which opts out via its own
 * `export const prerender = false`.
 *
 * Trailing slashes are required everywhere — keeps caching keys, sitemap
 * entries, and crawler canonicalisation in lockstep.
 */
export const prerender = true;
export const trailingSlash = 'always';
